var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"nav"}},[_c('CartSmall'),_c('Product')],1)}
var staticRenderFns = []

export { render, staticRenderFns }